import styled from 'styled-components';

import { Text } from '@/nova/components';

import { COLORS, MOBILE } from '../../../../theme/tokens';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

// Two labeled pills side by side on desktop (each flex:1, equal width); stacked full-width on mobile.
export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 12px;
  width: 100%;

  ${MOBILE} {
    flex-direction: column;
  }
`;

export const Notice = styled(Text)<{ $error: boolean }>`
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: ${({ $error }) => ($error ? COLORS.ctaSolid : COLORS.textMuted)};
`;
